export function tick(fn: (...args: any[]) => any) {
  return Promise.resolve().then(fn);
}
